import HighlightedTable, {
	HighlightedTableContent,
} from "../../../../common/HighlightedTable/HighlightedTable";
import MarkdownRenderer from "../../../../common/MarkdownRenderer/MarkdownRenderer";
import "./OurFramework.scss";

const comparisonColumns = [
	"mission",
	"vision",
	"philosophy",
	"commitment",
	"spirit",
	"promise",
] as const;

export type ColumnHeader = (typeof comparisonColumns)[number];

const OurFramework = ({
	sectionContent,
	isMobile,
}: {
	sectionContent: HighlightedTableContent<ColumnHeader>;
	isMobile: boolean;
}) => {
	return (
		<section className="our-framework">
			<div className="content-container">
				<MarkdownRenderer>{sectionContent.title}</MarkdownRenderer>
				<MarkdownRenderer>{sectionContent.content}</MarkdownRenderer>
				{isMobile ? (
					[sectionContent.flyORKA].map((column) => {
						return (
							<HighlightedTable
								key={column.title}
								columnsHeaders={sectionContent.columnsHeaders}
								columns={[column]}
								className="force-rounded-corners table--recommended"
								isMobile
							/>
						);
					})
				) : (
					<HighlightedTable
						columnsHeaders={sectionContent.columnsHeaders}
						columns={[sectionContent.flyORKA]}
					/>
				)}
			</div>
		</section>
	);
};

export default OurFramework;
